import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { AuthoritySection } from '../components/home/AuthoritySection';
import { ValueProps } from '../components/home/ValueProps';
import { ServicesSection } from '../components/home/ServicesSection';
import { FaqSection, faqData } from '../components/home/FaqSection';
import { ContactoScreen } from './ContactoScreen';
import { SEO } from '../components/shared/SEO';

export const HomeScreen = () => {
  return (
    <main className="home-screen">
      <SEO
        title="Contadores en Corrientes Capital"
        description="Estudio contable en Corrientes Capital. Contadores públicos matriculados especialistas en asesoramiento impositivo, liquidación de sueldos, monotributo y PyMEs en Corrientes."
        keywords="contadores en corrientes capital, estudio contable corrientes, contador publico corrientes, asesoramiento fiscal corrientes, monotributo corrientes, liquidacion de sueldos corrientes, rym contable"
        url="https://rymcontable.com.ar"
        faqSchema={faqData}
      />
      <HeroSection />
      <AuthoritySection />
      <ServicesSection />
      <ValueProps />
      <FaqSection />
      <ContactoScreen />
    </main>
  );
};
